import { useState, useCallback, useLayoutEffect } from 'react';

export const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(null);

    const updateDimensions = useCallback(() => {
        setWindowWidth(window.innerWidth);
    }, []);

    useLayoutEffect(() => {
        updateDimensions();

        window.addEventListener('resize', updateDimensions);

        return () => window.removeEventListener('resize', updateDimensions);
    }, [updateDimensions]);

    return windowWidth;
};
